import Typograf from 'typograf';

export const typograf = new Typograf({
  locale: ['ru'],
});
typograf.enableRule('common/nbsp/afterNumber');
